module.exports = __webpack_public_path__ + "img/follownew.88453129.jpg";